import React, {Component} from 'react'
import {
    Form,
    FormGroup,
    Label,
    Button,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col,
    InputGroup,
    InputGroupAddon
} from 'reactstrap'
import {
    AvForm,
    AvField,
    AvGroup,
    AvInput,
    AvFeedback
} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import {withRouter} from 'react-router-dom'

import createUserRoleMutation from '../../../queries/server/mutations/create_user_role'

class UserRoleCreate extends Component {

    state = {
        description: '',
    }

    render() {

        const {isOpen, toggle} = this.props
        const {description} = this.state

        return (
            <Mutation mutation={createUserRoleMutation}>
                {(createUserRoleMutationFunc, {loading}) => (
                    <Modal isOpen={isOpen}>
                        <AvForm onValidSubmit={() => {
                            createUserRoleMutationFunc({
                                variables: {
                                    data: {
                                        description,
                                    }
                                }
                            })
                                .then(({data}) => {
                                    this.props.history.push(`/user_roles/${data.upsert_user_roles.user_role_id}`)
                                })
                        }}>
                            <ModalHeader toggle={toggle}>
                                Create User Role
                            </ModalHeader>
                            <ModalBody>
                                <AvField
                                    required
                                    errorMessage="Required"
                                    label="Description*"
                                    name="description"
                                    id="description"
                                    bsSize="sm"
                                    value={description}
                                    onChange={(evt) => this.setState({description: evt.target.value})}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    size="sm"
                                    color="secondary"
                                    onClick={toggle}
                                >
                                    <FontAwesomeIcon
                                        color="#fff"
                                        icon="times"
                                    />{' '}
                                    Cancel
                                </Button>
                                <Button size="sm" color="success" disabled={loading}>
                                    <FontAwesomeIcon
                                        color="#fff"
                                        icon={loading ? 'spinner' : 'save'}
                                        spin={loading}
                                    />{' '}
                                    {loading ? 'Saving...' : 'Save'}
                                </Button>
                            </ModalFooter>
                        </AvForm>
                    </Modal>
                )}
            </Mutation>
        )
    }

}

UserRoleCreate = withRouter(UserRoleCreate)

export default UserRoleCreate

UserRoleCreate.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired
}

